<template>
    <b-table
            :narrowed="true"
            :striped="true"
            default-sort="name"
            :data="data"
    >
        <template slot-scope="props">
            <b-table-column label="Name" field="name" sortable>{{props.row.name}}</b-table-column>
            <b-table-column label="Timestamp" field="timestamp" centered>{{props.row.timestamp}}</b-table-column>
            <b-table-column label="Value" field="value" numeric>
                <app-topic-value :topic="props.row.topic"></app-topic-value>
            </b-table-column>
        </template>
    </b-table>
</template>

<script>
    import TopicValue from '../TopicValue';
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    components: {
      BTableColumn,
      appTopicValue: TopicValue
    },
    name: "state-list",
    props: ['states'],
    computed: {
      data() {
        if (!this.states) {
          return [];
        }

        return this.states;
      }
    }
  }
</script>

<style scoped>

</style>